export const AA_CODES = {
  Ala: "Alanine",
  Arg: "Arginine",
  Asn: "Asparagine",
  Asp: "Aspartic acid",
  Cys: "Cysteine",
  Glu: "Glutamic acid",
  Gln: "Glutamine",
  Gly: "Glycine",
  His: "Histidine",
  Ile: "Isoleucine",
  Leu: "Leucine",
  Lys: "Lysine",
  Met: "Methionine",
  Phe: "Phenylalanine",
  Pro: "Proline",
  Ser: "Serine",
  Thr: "Threonine",
  Trp: "Tryptophan",
  Tyr: "Tyrosine",
  Val: "Valine",
};
